import { useAuthStore, type CompleteAuthUser } from "../../../stores/useAuthStore";
import { resolveCurrentUser } from "./resolveCurrentUser";

export type EstablishCurrentUserResult =
  | { status: "ok"; user: CompleteAuthUser }
  | { status: "failed"; error: unknown }
  // The session was cleared (logout, failed refresh, cross-tab sign-out)
  // while the load was in flight — nothing was written, and whoever
  // cleared it is already handling the redirect.
  | { status: "aborted" };

/**
 * Loads the current user and writes it to the auth store — but only if no
 * clearAuth() happened in the meantime. The single place identity enters
 * the store, so a logout racing an in-flight load can never be undone.
 */
export async function establishCurrentUser(): Promise<EstablishCurrentUserResult> {
  const generation = useAuthStore.getState().authGeneration;
  const isStale = (): boolean => useAuthStore.getState().authGeneration !== generation;

  try {
    const user = await resolveCurrentUser({ isStale });
    if (isStale()) return { status: "aborted" };
    useAuthStore.getState().setUser(user);
    return { status: "ok", user };
  } catch (error) {
    if (isStale()) return { status: "aborted" };
    return { status: "failed", error };
  }
}
